import React from 'react'

import { Typography, Tooltip } from '@telavita-core/react-design-kit'

import {
  Container,
  BarWrapper,
  BarItem,
} from './styles'

interface HorizontalBarProps {
  hour: string
  percentage?: number
  value?: number
}

export function HorizontalBar({
  hour,
  percentage = null,
  value = null,
}: HorizontalBarProps): JSX.Element {

  function isPercentageNanOrNull(percentage: number): number {
    return isNaN(percentage) || !percentage ? 0 : percentage
  }

  return (
    <Container>
      <Typography variant='content3'>
        {hour}
      </Typography>
      {percentage === null && value === null
        ? (
          <Typography
            variant='content3'
            italic
            inlineStyles={{
              color: '#adadad',
            }}
          >
            Indisponível
          </Typography>
        )
        : (
          <div>
            <Tooltip
              theme='light'
              content={
                <Typography variant='content3'>
                  <strong>{value} {value === 1 ? 'agendamento' : 'agendamentos'}</strong><br />às {hour}
                </Typography>
              }
            >
              <BarWrapper>
                <BarItem width={isPercentageNanOrNull(percentage)} />
                <Typography
                  variant='content3'
                  color='primary'
                  weight='bolder'
                >
                  {isPercentageNanOrNull(percentage)}%
                </Typography>
              </BarWrapper>
            </Tooltip>
          </div>
        )
      }
    </Container>
  )
}